import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';  
import BreadcrumbMenuStyles from '../assets/css/breadcrumbMenu.styles';

interface BreadcrumbItem {
  label: string;
  path: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const BreadcrumbMenu: React.FC<BreadcrumbProps> = ({ items }) => {
  const theme = useTheme();

  return (
    <nav aria-label="breadcrumb">
      <ol style={BreadcrumbMenuStyles.breadcrumb}>
        {items.map((item, index) => (
          <li key={index} style={BreadcrumbMenuStyles.breadcrumbItem}>
            {index !== 0 && <span style={BreadcrumbMenuStyles.breadcrumbSeparator}>{' > '}</span>}
            {index === items.length - 1 ? (
              <span style={BreadcrumbMenuStyles.breadcrumbItemActive}>{item.label}</span>
            ) : (
              <Link to={item.path} style={BreadcrumbMenuStyles.breadcrumbLink}>
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default BreadcrumbMenu;
